import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const CenteredTitle = styled.h1`
  margin-bottom: 20px;
  font-size: 24px;
`;

const progressAnimation = keyframes`
  0% { left: -50%; }
  100% { left: 100%; }
`;

const ProgressBarContainer = styled.div`
  width: 300px;
  height: 4px;
  background-color: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
`;

const ProgressBar = styled.div`
  width: 50%;
  height: 100%;
  background-color: #00c300;
  position: relative;
  animation: ${progressAnimation} 1.5s infinite linear;
`;

const SERVICE_MAP = {
  realestate_agent:    'ra',
  realestate_client:   'rc',
  realestate_tenant:   'rt',
  realestate_benefits: 'rb',
  recruit_agent:       'raj',
  recruit_client:      'rcj',
  wk: 'wk',
};

const BASE_URL = {
  'ra':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=lNrLll&liff_id=2000515070-gr8Ne6Kv',
  'rc':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=Eksu9K&liff_id=2000515070-gr8Ne6Kv',
  'rt':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=yhhxdI&liff_id=2000515070-gr8Ne6Kv',
  'rb':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=wUAILq&liff_id=2000515070-gr8Ne6Kv',
  'raj':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=uwwYbS&liff_id=2000515070-gr8Ne6Kv',
  'rcj':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=MNJXlX&liff_id=2000515070-gr8Ne6Kv',
  'wk':'https://liff.line.me/2008052872-Qn0qZ3p0/landing?follow=%40371iymcd&lp=CCfu7E&liff_id=2008052872-Qn0qZ3p0'
};

const ERROR_URL = {
  'ra':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=j0Vh1j&liff_id=2000515070-gr8Ne6Kv',
  'rc':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=akDkGf&liff_id=2000515070-gr8Ne6Kv',
  'rt':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=bDwZuT&liff_id=2000515070-gr8Ne6Kv',
  'rb':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=Llm9PP&liff_id=2000515070-gr8Ne6Kv',
  'raj':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=qmmaAa&liff_id=2000515070-gr8Ne6Kv',
  'rcj':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=dBW3EZ&liff_id=2000515070-gr8Ne6Kv',
  'wk':'https://liff.line.me/2008052872-Qn0qZ3p0/landing?follow=%40371iymcd&lp=yykSWI&liff_id=2008052872-Qn0qZ3p0'
};

const UNKNOWNN_MEDIA_MAP = {
  'ra': {
    'ig': 'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=FtlrOx&liff_id=2000515070-gr8Ne6Kv',
    'glis': 'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=c5E4x2&liff_id=2000515070-gr8Ne6Kv',
    'gdem':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=LlJ5sl&liff_id=2000515070-gr8Ne6Kv'    
  },
  'raj': {
    'ig':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=7KYSOt&liff_id=2000515070-gr8Ne6Kv',
    'glis':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=uKjEqb&liff_id=2000515070-gr8Ne6Kv',
    'link':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=AAliW4&liff_id=2000515070-gr8Ne6Kv'
  },
  'rcj':{
    'ig':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=G3Kgup&liff_id=2000515070-gr8Ne6Kv',
    'glis':'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=bXKYO6&liff_id=2000515070-gr8Ne6Kv'
  },
  'wk':{
    
  }
  // 他のサービスとプラットフォームの組み合わせも同様に追加
};

const DEFAULT_URL = 'https://st.rakusumu.jp/servicelist';

function App() {
  const [status, setStatus] = useState('loading'); // 'loading', 'redirecting', 'error'

  // 安全にデコードする関数（多重エンコードにも対応）
  const safeDecodeURIComponent = (str) => {
    if (!str) return str;

    let decoded = str;
    const hasEncodedSequence = /%[0-9A-Fa-f]{2}/;

    try {
      while (hasEncodedSequence.test(decoded)) {
        const next = decodeURIComponent(decoded);
        if (next === decoded) {
          break;
        }
        decoded = next;
      }
    } catch (e) {
      console.log('デコード失敗:', decoded, e);
      return decoded;
    }

    return decoded;
  };

  // URL とパラメータを取得（ネストしたパラメータも処理）
  const urlObj = new URL(window.location.href);
  const params = urlObj.searchParams;
  const paramsString = params.toString();
  
  // デバッグ用のログ出力
  console.log('現在のURL:', window.location.href);
  console.log('パラメータ一覧:', Array.from(params.entries()));
  
  // refererパラメータがある場合、その中身も解析
  let gclid = params.get('gclid');
  let id = params.get('utm_content') || '';
  
  const referer = params.get('referer');
  let refererHostname = '';
  let refererPathname = '';
  if (referer) {
    console.log('refererパラメータ発見:', referer);
    try {
      // refererを安全にデコード
      const decodedReferer = safeDecodeURIComponent(referer);
      console.log('デコード済みreferer:', decodedReferer);

      const refererUrl = new URL(decodedReferer);
      refererHostname = refererUrl.hostname;
      refererPathname = safeDecodeURIComponent(refererUrl.pathname);
      const refererParams = refererUrl.searchParams;
      console.log('referer内のパラメータ:', Array.from(refererParams.entries()));

      // referer内のパラメータを優先して使用
      gclid = refererParams.get('gclid') || gclid;
      id = refererParams.get('utm_content') || id;
    } catch (e) {
      console.log('refererの解析に失敗:', e);
    }
  }

  // 最終的に安全にデコード
  gclid = safeDecodeURIComponent(gclid);
  id = safeDecodeURIComponent(id);

  const pathSeg = urlObj.pathname.split('/').filter(Boolean);
  const pageName = pathSeg[0] || '';
  const media = pathSeg[1] || '';
  let service = SERVICE_MAP[pageName] || '';
  let specialRedirectUrl = '';

if (refererHostname === 'partner.rakusumu.jp') {
  // recruit_agent が「パスの最後」にあるか判定
  if (/\/recruit_agent\/?$/.test(refererPathname)) {
    specialRedirectUrl =
      'https://liff.line.me/2000515070-gr8Ne6Kv/landing?follow=%40702ficiu&lp=5H8ecl&liff_id=2000515070-gr8Ne6Kv';
  }
}
  
  // デバッグ用のログ出力
  console.log('取得したパラメータ:');
  console.log('- gclid:', gclid);
  console.log('- utm_content (id):', id);
  console.log('- pathSeg:', pathSeg);
  console.log('- pageName:', pageName);

  useEffect(() => {
    const redirectWith = (baseUrl) => {
      console.log('redirectWith呼び出し:', baseUrl);

      const url = new URL(baseUrl, window.location.origin);
      const redirectParams = new URLSearchParams(paramsString);

      const normalizedGclid = gclid;
      const normalizedUtmContent = id;

      if (normalizedGclid) {
        redirectParams.set('gclid', normalizedGclid);
      }

      if (normalizedUtmContent) {
        redirectParams.set('utm_content', normalizedUtmContent);
      }

      redirectParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });

      if (normalizedGclid) {
        url.searchParams.set('var_2204660', normalizedGclid);
      }

      const finalUrl = url.toString();
      console.log('最終リダイレクトURL:', finalUrl);

      setStatus('redirecting');
      setTimeout(() => {
        console.log('リダイレクト実行中...');
        window.location.href = finalUrl;
      }, 1000);
    };

    const handleRedirect = async () => {

      if (specialRedirectUrl) {
        console.log('specialRedirectUrl使用:', specialRedirectUrl);
        return redirectWith(specialRedirectUrl);
      }

      if (!service) {
        console.log('serviceなし → DEFAULT_URLへ');
        return redirectWith(DEFAULT_URL);
      }
      
      // ID がない場合
      if (!id) {
        console.log('IDなし → フォールバック処理');
        
        if (media && UNKNOWNN_MEDIA_MAP[service]?.[media]) {
          console.log('UNKNOWNN_MEDIA_MAP使用:', UNKNOWNN_MEDIA_MAP[service][media]);
          return redirectWith(UNKNOWNN_MEDIA_MAP[service][media]);
        }
        
        if (BASE_URL[service]) {
          console.log('BASE_URL使用:', BASE_URL[service]);
          return redirectWith(BASE_URL[service]);
        }
        
        if (ERROR_URL[service]) {
          console.log('ERROR_URL使用:', ERROR_URL[service]);
          return redirectWith(ERROR_URL[service]);
        }
        
        console.log('全てのフォールバック失敗 → DEFAULT_URL');
        return redirectWith(DEFAULT_URL);
      }
      // ID がある場合
      console.log('service', service);
      console.log('id', id);
      const apiUrl = `https://redirect.microcms.io/api/v1/map?filters=utm_service[equals]${service}[and]utm_content[equals]${id}`;
      try {
        const res = await fetch(apiUrl, {
          headers: { 'X-MICROCMS-API-KEY': process.env.REACT_APP_API_KEY },
        });
        const data = await res.json();
        const redirectUrl = data.contents?.[0]?.redirect_url;
        if (redirectUrl) {
          return redirectWith(redirectUrl);
        }
        // フォールバック
        if (media && UNKNOWNN_MEDIA_MAP[service]?.[media]) {
          return redirectWith(UNKNOWNN_MEDIA_MAP[service][media]);
        }
        if (ERROR_URL[service]) {
          return redirectWith(ERROR_URL[service]);
        }
        return redirectWith(DEFAULT_URL);
      } catch (e) {
        console.error('APIエラー', e);
        if (media && UNKNOWNN_MEDIA_MAP[service]?.[media]) {
          return redirectWith(UNKNOWNN_MEDIA_MAP[service][media]);
        }
        if (ERROR_URL[service]) {
          return redirectWith(ERROR_URL[service]);
        }
        return redirectWith(DEFAULT_URL);
      }
    };

    handleRedirect();
  }, [service, id, media, gclid, specialRedirectUrl, paramsString]);

  if (status === 'loading' || status === 'redirecting') {
    return (
      <CenteredContainer>
        <CenteredTitle>
          LINEを開いています。<br/>
          このままお待ちください。
        </CenteredTitle>
        <ProgressBarContainer>
          <ProgressBar />
        </ProgressBarContainer>
      </CenteredContainer>
    );
  }

  return null;
}

export default App;
